import React from "react"
import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import {AlignType} from "./align"

export default function ToolbarAlignButton(state: any, props: any) {
    const {elementFormat, options} = props.menuParams

    let option: any
    _.some(options, o=>{
        if (o.options) {
            option = _.find(o.options, option=>option.value === elementFormat)
        } else if (o.value === elementFormat) {
            option = o
        }

        return !!option
    })

    if (!option) option = _.find(options, o=>o.value === AlignType.LEFT)

    const classes = Classes("flex-row-center-center", {
        'show-popover': state.showPopover
    })

    return (
        <ControlButtonStandard className={classes}>
            {option.icon && <div className={Classes("ui5-ico-16", option.icon)}/>}
        </ControlButtonStandard>
    )
}